import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { USER_ROLES } from "../../constants/userRoles"; // 🔥 IMPORTAMOS LOS ROLES
import iconWhite from "../../assets/icon_white.png";

// 🔥 1. Recibir las props isOpen y closeSidebar
export default function Sidebar({ isOpen, closeSidebar }) {
  // 🔥 Sacamos también el "user" del contexto
  const { logout, user } = useAuth();

  // 🔥 Verificamos si es gobierno
  const isGovernment = user?.roleId === USER_ROLES.GOVERNMENT || user?.roleId === USER_ROLES.GOVERNMENT_ADMIN;
  const isEmployee = user?.roleId === USER_ROLES.EMPLOYEE || user?.roleId === USER_ROLES.EMPLOYEE_ADMIN;

  return (
    <>
      <style>{`
        .sidebar {
          display: flex;
          flex-direction: column;
          width: 260px;
          height: 100vh;
          background-color: #707070;
          color: white;
          padding: 20px 0;
          box-sizing: border-box;
        }

        .sidebar-logo {
          padding: 0 40px 30px 40px;
          text-align: center;
        }

        .logo-icon {
          width: 100%;
          max-width: 120px;
        }

        .sidebar-menu {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .menu-item {
          padding: 15px 30px;
          text-decoration: none;
          color: #E0E0E0;
          font-weight: 500;
          transition: all 0.2s;
          border-left: 4px solid transparent;
        }

        .menu-item:hover {
          background-color: rgba(255, 255, 255, 0.1);
          color: white;
        }

        .menu-item.active {
          background-color: rgba(234, 192, 36, 0.15);
          color: #EAC024;
          border-left: 4px solid #EAC024;
        }

        /* --- BOTÓN DE LOGOUT ABAJO ROJO PASTEL --- */
        .sidebar-footer {
          padding: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .logout-btn {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 12px;
          background-color: #ed2222; /* Rojo Pastel */
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 4px 6px rgba(255, 107, 107, 0.2);
        }

        .logout-btn:hover {
          background-color: #ff2d2d;
          transform: translateY(-1px);
        }

        .logout-icon {
          width: 20px;
          height: 20px;
        }
      `}</style>

      {/* 🔥 2. Clase dinámica que añade 'open' cuando el estado es true */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        
        {/* 🔥 3. BOTÓN PARA CERRAR EL SIDEBAR EN MÓVILES (La "X") */}
        <button className="close-sidebar-btn" onClick={closeSidebar}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="sidebar-logo">
          <img src={iconWhite} alt="Logo" className="logo-icon" />
        </div>
        
        <div className="sidebar-menu">
          <NavLink
            to="/tracking"
            className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
            onClick={closeSidebar} /* Opcional: Cierra el menú en móvil al hacer clic */
          >
            Monitoreo
          </NavLink>

          {/* Planning is only available for employees */}
          {isEmployee && (
            <NavLink
              to="/planning"
              className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
              onClick={closeSidebar}
            >
              Planificación
            </NavLink>
          )}

          {/* 🔥 OCULTAMOS LA PESTAÑA SI ES GOBIERNO */}
          {!isGovernment && (
            <NavLink
              to="/expansion"
              className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
              onClick={closeSidebar} /* Opcional: Cierra el menú en móvil al hacer clic */
            >
              Expansión
            </NavLink>
          )}

          <NavLink 
            to="/reports" 
            className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
            onClick={closeSidebar} /* Opcional: Cierra el menú en móvil al hacer clic */
          >
            Reportes
          </NavLink>  
        </div>

        <div className="sidebar-footer">
          <button onClick={logout} className="logout-btn">
            <svg 
              className="logout-icon" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            Cerrar sesión
          </button>
        </div>
      </aside>
    </>
  );
}